function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#paper_plane_svg__clip0_70_1901)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M21.466 6.478c.502-1.791.752-2.687.52-3.302a2 2 0 00-1.162-1.162c-.615-.233-1.51.018-3.302.52L7.296 5.397C4.466 6.19 3.05 6.586 2.64 7.258a2 2 0 00-.09 1.917c.345.708 1.716 1.236 4.459 2.29l2.663 1.024c.488.188.733.282.938.429a2 2 0 01.471.47c.146.206.24.45.428.94l1.024 2.662c1.055 2.743 1.583 4.114 2.291 4.459a2 2 0 001.916-.09c.673-.41 1.07-1.825 1.862-4.655l2.863-10.226z",
  fill: "#D8DAE7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 13l1.534 3.99c1.055 2.743 1.583 4.114 2.291 4.459a2 2 0 001.916-.09c.673-.41 1.07-1.825 1.862-4.655l2.863-10.226c.502-1.791.752-2.687.52-3.302a2 2 0 00-1.162-1.162c-.615-.233-1.51.018-3.302.52L7.296 5.397C4.466 6.19 3.05 6.586 2.64 7.258a2 2 0 00-.09 1.917c.345.708 1.716 1.236 4.459 2.29L11 13zm0 0l3-3",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "paper_plane_svg__clip0_70_1901"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    stroke: "#D8DAE7"
  }, props), _ref, _ref2);
};

export default SvgPaperPlane;